import { Hero } from "@/components/Hero";
import { TrustStrip, ShopGrid, StandardStrip, StaffPicks, GoodQuestions } from "@/components/HomeSections";
import { PageShell, usePageMeta, useJsonLd, productLd } from "@/components/PageShell";
import { PRODUCTS } from "@/data/catalog";

export default function Home() {
  usePageMeta("Dirty Paws Apothecary · Small-batch mushroom powders for dogs",
    "Small-batch mushroom powders for dogs, made in Alberta. Turkey tail, reishi, cordyceps and lion's mane. One daily measure, every ingredient named, every batch numbered.");
  useJsonLd("product-schema", PRODUCTS.map(productLd));
  return (
    <PageShell testid="home-page">
      <Hero />
      <TrustStrip />
      <ShopGrid />
      <StandardStrip />
      <StaffPicks />
      <GoodQuestions />
    </PageShell>
  );
}
